module.exports = "<div class=\"spinner\">\n  <div class=\"spinner-blades-container\"></div>\n</div>\n"